/**
 * @fileoverview O endereço a partir do CEP (03/11/2026, contratação nova): o
 * navegador pergunta à ViaCEP só o CEP e preenche rua, bairro, cidade e UF. É
 * uma ajuda: sem resposta, CEP desconhecido ou demora, devolve null e a pessoa
 * digita. Quem confere o endereço continua sendo o servidor.
 */

const TIMEOUT_MS = 4000;

export const lookupZipCode = async (zipCode) => {
  const digits = String(zipCode || "").replace(/\D/g, "");
  if (digits.length !== 8) return null;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  try {
    const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`, { signal: controller.signal });
    if (!response.ok) return null;
    const data = await response.json();
    if (!data || data.erro) return null;
    return { street: data.logradouro || "", neighborhood: data.bairro || "", city: data.localidade || "", state: data.uf || "" };
  } catch (err) {
    return null;
  } finally {
    clearTimeout(timer);
  }
};
